export default "/images/3d7a8f310f97dceab8d90b11a4b68fc2.avif";